import { Checkbox, Col, Form, Input, Row, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";

const Fitting = () => {
  const data2 = [
    {
      key: 1,
      noiDung: "Loại kính",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Thông số kính",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Vị trí kính",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Vùng điều trị",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Vùng quy hồi",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Vùng Landing",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Vùng rìa",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Refit",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Over refraction",
      mp: "",
      mt: "",
    },
    {
      key: 1,
      noiDung: "Final lens",
      mp: "",
      mt: "",
    },
  ];

  const renderCell = (i: number | string, side: string) => {
    if (i == 7) {
      return (
        <td>
          <div style={{ display: "grid", gap: 5 }}>
            <Form.Item name={["fitting", side, i, 0]}>
              <Input />
            </Form.Item>
            <Form.Item name={["fitting", side, i, 1]}>
              <Input />
            </Form.Item>
            <Form.Item name={["fitting", side, i, 2]}>
              <Input />
            </Form.Item>
          </div>
        </td>
      );
    } else if (i == 2) {
      return (
        <td className="divice-td">
          <td style={{ flex: 1, paddingRight: 5 }}>
            <Form.Item name={["fitting", side, i, 0]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Định tâm</Checkbox>
            </Form.Item>
            <Form.Item name={["fitting", side, i, 1]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Không định tâm</Checkbox>
            </Form.Item>
          </td>
          <td>
            <Form.Item name={["fitting", side, i, 2]}>
              <TextArea cols={3} />
            </Form.Item>
          </td>
        </td>
      );
    } else if (i == 3) {
      return (
        <td className="divice-td">
          <td style={{ flex: 1, paddingRight: 5 }}>
            <Form.Item name={["fitting", side, i, 1]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Nhỏ {`(<4mm)`}</Checkbox>
            </Form.Item>
            <Form.Item name={["fitting", side, i, 2]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Vừa {`(>4mm)`}</Checkbox>
            </Form.Item>
          </td>
          <td>
            <Form.Item name={["fitting", side, i, 3]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Tròn, đều</Checkbox>
            </Form.Item>

            <Form.Item name={["fitting", side, i, 4]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Không tròn</Checkbox>
            </Form.Item>
          </td>
        </td>
      );
    } else if (i == 4) {
      return (
        <td className="divice-td">
          <td style={{ flex: 1, paddingRight: 5 }}>
            <Form.Item name={["fitting", side, i, 0]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>
                Rõ nét,mắt bò,tiêu chuẩn
              </Checkbox>
            </Form.Item>
            <Form.Item name={["fitting", side, i, 1]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>
                Không rõ ràng, tràn nước mắt
              </Checkbox>
            </Form.Item>
          </td>
        </td>
      );
    } else if (i == 5) {
      return (
        <td className="divice-td">
          <td style={{ flex: 1, paddingRight: 5 }}>
            <Form.Item name={["fitting", side, i, 0]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>
                Tiếp xúc giác mặc {`(định tâm tốt)`}
              </Checkbox>
            </Form.Item>
            <Form.Item name={["fitting", side, i, 1]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>
                Tràn nước mắt {`(định tâm kém)`}
              </Checkbox>
            </Form.Item>
          </td>
        </td>
      );
    } else if (i == 6) {
      return (
        <td className="divice-td">
          <td style={{ flex: 1, paddingRight: 5 }}>
            <Form.Item name={["fitting", side, i, 0]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Mỏng {`(chặt)`}</Checkbox>
            </Form.Item>
            <Form.Item name={["fitting", side, i, 1]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Lỏng {`(dày)`}</Checkbox>
            </Form.Item>
            <Form.Item name={["fitting", side, i, 2]} valuePropName="checked">
              <Checkbox style={{ width: "100%" }}>Vừa {`(tối ưu)`}</Checkbox>
            </Form.Item>
          </td>
        </td>
      );
    } else
      return (
        <td>
          <Form.Item name={["fitting", side, i]}>
            <Input />
          </Form.Item>
        </td>
      );
  };

  const boDungCu = [
    { name: "coTay", title: "Dụng cụ cọ tay" },

    { name: "ngamRua", title: "Dụng dịch ngâm rửa" },
    { name: "Bio", title: "BIO Clean" },
    { name: "Boston", title: "Boston Advance" },
    { name: "hopDung", title: "Hộp đựng" },
  ];
  return (
    <Row gutter={8}>
      <Col span={19}>
        <table>
          <thead>
            <th colSpan={2}>Nội dung</th>
            <th>MP</th>
            <th>MT</th>
          </thead>
          <tbody>
            {data2.map((e, i) => (
              <tr>
                {i === 7 ? (
                  <>
                    <td style={{ width: 150 }}>{e.noiDung}</td>
                    <td
                      style={{
                        display: "grid",
                        gap: 5,
                        border: "none",
                        width: 310,
                        paddingLeft: 0,
                      }}
                    >
                      <td style={{ border: "none" }}>Lần</td>
                      <td style={{ border: "none" }}>Lần</td>
                      <td style={{ border: "none" }}>Lần</td>
                    </td>
                  </>
                ) : (
                  <td colSpan={2}>{e.noiDung}</td>
                )}
                {renderCell(i, "mp")}
                {renderCell(i, "mt")}
              </tr>
            ))}
          </tbody>
        </table>
      </Col>

      <Col span={5} style={{ margin: "auto" }}>
        <div
          style={{
            border: "1px solid #f0f0f0",
            height: "250px",
            width: "100%",
          }}
        >
          <Row style={{ borderBottom: "1px solid #f0f0f0", padding: 5 }}>
            Bộ dụng cụ
          </Row>
          <Space direction="vertical" style={{ padding: 10 }}>
            {boDungCu.map((el) => (
              <Row key={el.name}>
                <Form.Item name={["fitting", el.name]} valuePropName="checked">
                  <Checkbox style={{ width: "100%" }}>{el.title}</Checkbox>
                </Form.Item>
              </Row>
            ))}
          </Space>
        </div>
      </Col>
    </Row>
  );
};

export default Fitting;
